import { rotateAnimation, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface IconWrapperProps {
  isLoading: boolean
}

export const IconWrapper = styled.span<IconWrapperProps>`
  margin-right: ${Spacing.S4};

  > svg {
    ${({ isLoading }) => isLoading && rotateAnimation()};
  }
`
